import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import UserAvatarOrganizationAndName from 'src/components/UserAvatarOrganizationAndName/UserAvatarOrganizationAndName'
import { ExtendCurrency } from 'src/enums'
import Crncy from 'src/localization/Crncy'
import Trns from 'src/localization/Trns'
import {
  ApprovalRuleResponse,
  OrganizationsListModel,
} from 'src/models/organizations.models'
import { UserListModel } from 'src/models/user.models'
import { toDollars } from 'src/utils/currency.utils'
import { css } from 'styled-components'

interface OutOfPocketExpensesBoxContentProps {
  organization: OrganizationsListModel
  approver?: UserListModel
  cardApprovalRules?: ApprovalRuleResponse
  cardApprovalsEnabled: boolean
}

const CardApprovalsBoxContent: React.FC<OutOfPocketExpensesBoxContentProps> = (
  props,
): React.ReactElement => {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          row-gap: 40px;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              12,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )}
          `}
        >
          <Trns
            source={
              'Assign an Owner or Admin to approve virtual card requests, updates, and creations across your organization.'
            }
          />
        </span>
        <div
          css={css`
            display: flex;
            flex-direction: column;
          `}
        >
          <span
            css={css`
              ${getFontCss(
                14,
                styleConstants.colors.gray_darkest,
                styleConstants.fontFamilies.regular,
              )};
              display: flex;
              align-items: center;
            `}
          >
            <Trns source={'Card Approver Rule'} />
          </span>
          <span
            css={css`
              ${getFontCss(
                16,
                themeConstants.colors.font_primary,
                styleConstants.fontFamilies.regular,
              )};
            `}
          >
            <Trns source={props.cardApprovalsEnabled ? 'ON' : 'OFF'} />
          </span>
        </div>
        {props.cardApprovalsEnabled && (
          <div
            css={css`
              display: flex;
              flex-direction: column;
            `}
          >
            <span
              css={css`
                ${getFontCss(
                  14,
                  styleConstants.colors.gray_darkest,
                  styleConstants.fontFamilies.regular,
                )};
                display: flex;
              `}
            >
              <Trns source={'Card Approver'} />
            </span>
            {props.approver !== undefined ? (
              <UserAvatarOrganizationAndName user={props.approver} />
            ) : (
              <span
                css={css`
                  ${getFontCss(
                    16,
                    themeConstants.colors.font_primary,
                    styleConstants.fontFamilies.regular,
                  )};
                `}
              >
                <Trns source={'No Approver Assigned'} />
              </span>
            )}
            <div
              css={css`
                display: flex;
                flex-direction: column;
                margin-top: 28px;
              `}
            >
              <span
                css={css`
                  ${getFontCss(
                    14,
                    styleConstants.colors.gray_darkest,
                    styleConstants.fontFamilies.regular,
                  )};
                  margin-bottom: 8px;
                `}
              >
                <Trns source={'Required for Cards Over'} />
              </span>
              {(
                Object.keys(ExtendCurrency) as Array<
                  keyof typeof ExtendCurrency
                >
              ).map((currencyCode) => {
                const threshold =
                  props.cardApprovalRules?.thresholds[
                    `${currencyCode.toLowerCase()}Cents` as keyof typeof props.cardApprovalRules.thresholds
                  ]
                const showUsdDefault =
                  props.organization.currencies?.length === 0 &&
                  currencyCode === 'Usd'
                if (
                  (typeof threshold === 'undefined' || // if no treshold exists for this currency on the approvalRules OR
                    !props.organization.currencies?.find(
                      (currency) =>
                        currency.currencyCode === currencyCode.toUpperCase(),
                    )) && // the currency does not exist in the organization's currencies AND
                  !showUsdDefault // we're not showing the USD default
                ) {
                  return null
                }
                return (
                  <span
                    key={currencyCode}
                    css={css`
                      margin-bottom: 8px;
                      ${getFontCss(
                        16,
                        themeConstants.colors.font_primary,
                        styleConstants.fontFamilies.regular,
                      )};
                    `}
                  >
                    <Trns
                      source={'${threshold} ${faintText}'}
                      expressions={{
                        threshold: (
                          <Crncy
                            currency={currencyCode}
                            amount={threshold ? toDollars(threshold) : 0}
                            hideCurrency
                          />
                        ),
                        faintText: (
                          <span
                            css={css`
                              ${getFontCss(
                                16,
                                styleConstants.colors.gray_darkest,
                                styleConstants.fontFamilies.regular,
                              )};
                            `}
                          >
                            {currencyCode.toUpperCase()}
                          </span>
                        ),
                      }}
                    />
                  </span>
                )
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

export default CardApprovalsBoxContent
